import { render, staticRenderFns } from "./ItemShipmentHistoryByVendorModal.vue?vue&type=template&id=567ff4bb"
import script from "./ItemShipmentHistoryByVendorModal.vue?vue&type=script&lang=js"
export * from "./ItemShipmentHistoryByVendorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports